import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-mobile-page',
  templateUrl: './add-mobile-page.component.html',
  styleUrls: ['./add-mobile-page.component.scss']
})
export class AddMobilePageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
